import z from "zod";

// Also validates the v1 payloads of Deleted/Revived/Revoked/Unlinked, which are only { reason }. The keys
// v1 omits therefore need .nullish() — it accepts a missing key as well as a null one, where .nullable()
// would reject the whole v1 object. Normalization never backfills these to null for a v1 event, so
// downstream, undefined on this event type means either "this arrived as v1" or "the backend sent a
// valid absent value" — deliberately not distinguished, since every renderer already treats both the
// same way via `?? unknown`.
const licenseReasonDataSchema = z.object({
    ip: z.string().nullish(),
    code: z.string().nullish(),
    chargeId: z.string().nullish(),
    deviceSerial: z.string().optional(),
    reason: z.string().nullable(),
});

const licenseUserDataSchema = z.object({
    ip: z.string().nullable(),
    code: z.string().nullable(),
    chargeId: z.string().nullable(),
    deviceSerial: z.string(),
    user: z.string(),
});

// Also validates the v1 payload, which is only { group } — see licenseReasonDataSchema above, including
// the note on why an undefined field here is left ambiguous between "v1" and "validly absent".
const licenseMovedSchema = z.object({
    ip: z.string().nullish(),
    code: z.string().nullish(),
    chargeId: z.string().nullish(),
    deviceSerial: z.string().optional(),
    group: z.object({ old: z.number().nullable(), new: z.number() }),
});

export { licenseMovedSchema, licenseReasonDataSchema, licenseUserDataSchema };
